import Column from '@components/Column';
import Header from '@components/Header';
import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import useCompleteAnimation from './hooks/useCompleteAnimation';
import img from './img.png';
import styles from './styles.module.scss';

function Complete() {
    const ref = useRef<HTMLDivElement>(null);
    const cardRef = useRef<HTMLImageElement>(null);
    const { t } = useTranslation('gift');
    const { message } = useCompleteAnimation({ ref, cardRef });
    return (
        <div className={`${styles.container} ${styles.none} ${styles.hide}`}
            ref={ref}>
            <Header noBackIcon title={t('giftOrder.completeTitle')}/>
            <div className={styles.cardWrapper}>
                <Image src={img}
                    // @ts-ignore
                    ref={cardRef}
                    className={styles.card}
                    alt={t('giftOrder.completeCardImageAlt')} />
            </div>
            <Column align='center' spacing={18}>
                <Text color={colors.gray7} size='3xl' fontWeight='bold' >
                    {t('giftOrder.completeMessage')}
                </Text>
                <Text color={colors.gray7} className={styles.message}>
                    {message}
                </Text>
            </Column>
        </div>
    );
}

export default Complete;
